import { employees } from '../../data/employees';
import PageHeader from '../../components/PageHeader/PageHeader';
import './AboutScreen.css';

const AboutScreen = () => {
  return (
    <div className="about-screen">
      <PageHeader
        eyebrow="Um okkur"
        title="Traust þjónusta með áratuga reynslu"
        lede="Vélvirki ehf. hefur þjónað sjávarútvegi og iðnaði í áratugi með hágæða stálsmíði, rennismíði og viðgerðarþjónustu."
      />

      <div className="about-content">
        <div className="about-text">
          <h2>Hver við erum</h2>
          <p>
            Vélvirki ehf. hefur þjónað sjávarútvegi og iðnaði í áratugi með hágæða stálsmíði,
            rennismíði og viðgerðarþjónustu. Við leggjum metnað í fagmennsku, áreiðanleika og
            lausnir sem standast kröfur viðskiptavina.
          </p>
          <p>
            Við tökum að okkur fjölbreytt verkefni, allt frá smábátaviðgerðum til flókinna
            iðnaðarlausna. Með nýjum eigendum, sem koma með ferska sýn og mikla reynslu,
            byggjum við áfram á traustum grunni fyrirtækisins og höldum áfram að veita
            persónulega og sérsniðna þjónustu fyrir viðskiptavini okkar.
          </p>
        </div>

        <section className="employees-section">
          <h2>Starfsmenn</h2>
          <div className="employees-grid">
            {employees.map(employee => (
              <div key={employee.id} className="employee-card">
                {employee.image && (
                  <img
                    src={employee.image}
                    alt={employee.name}
                    className="employee-image"
                  />
                )}
                <h3>{employee.name}</h3>
                <p className="employee-role">{employee.role}</p>
                {employee.phone && (
                  <p className="employee-phone">{employee.phone}</p>
                )}
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutScreen;
